module.exports = __webpack_public_path__ + "img/FullAnimation1.e9de2625.jpg";